var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_754",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 129
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 63.6103,
    fill: "#C4C4C4",
    stroke: "#F8BB54",
    strokeWidth: 1.77931
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 27.0501C-37.4844 27.0501 -7.44941 21.4863 0.299994 2.01352C7.71125 -16.6533 38.2404 -21.6709 38.2404 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 36.4093C-37.4844 36.4093 -0.636166 29.9878 8.85543 6.48526C17.905 -15.9514 55.3252 -21.6709 55.3252 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 45.7948C-37.4844 45.7948 6.15098 38.4893 17.3849 11.009C28.0987 -15.2753 72.4102 -21.6709 72.4102 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 55.1542C-37.4844 55.1542 12.9641 46.9908 25.9403 15.4808C38.2924 -14.5733 89.4951 -21.6709 89.4951 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 64.5136C-37.4844 64.5136 19.7773 55.4923 34.4958 19.9784C48.486 -13.8714 106.554 -21.6709 106.554 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 73.899C-37.4844 73.899 26.5644 64.0196 43.0252 24.476C58.7058 -13.1955 123.639 -21.6709 123.639 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 83.2584C-37.4844 83.2584 33.3776 72.495 51.5807 28.9739C68.8996 -12.4935 140.724 -21.6709 140.724 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 92.6178C-37.4844 92.6178 40.1908 80.9965 60.11 33.4456C79.0932 -11.7916 157.809 -21.6709 157.809 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 102.003C-37.4844 102.003 46.9778 89.5241 68.6655 37.9692C89.2871 -11.1157 174.868 -21.6709 174.868 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 111.362C-37.4844 111.362 53.7911 98.0256 77.195 42.467C99.4807 -10.4137 191.952 -21.6709 191.952 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 120.747C-37.4844 120.747 60.6041 106.527 85.7505 46.9647C109.674 -9.71177 209.037 -21.6709 209.037 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 130.108C-37.4844 130.108 67.3913 115.029 94.2799 51.4625C119.868 -9.0357 226.122 -21.6709 226.122 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 139.466C-37.4844 139.466 74.2044 123.53 102.835 55.9341C130.062 -8.33373 243.206 -21.6709 243.206 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 148.851C-37.4844 148.851 81.0177 132.032 111.391 60.4578C140.256 -7.63176 260.266 -21.6709 260.266 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 158.212C-37.4844 158.212 87.8047 140.533 119.92 64.9296C150.449 -6.95589 277.351 -21.6709 277.351 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 167.572C-37.4844 167.572 94.618 149.034 128.476 69.4272C160.643 -6.25392 294.436 -21.6709 294.436 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 176.957C-37.4844 176.957 101.431 157.561 137.005 73.9251C170.837 -5.55195 311.52 -21.6709 311.52 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.4844 186.316C-37.4844 186.316 108.218 166.037 145.56 78.4227C181.031 -4.87609 328.58 -21.6709 328.58 -21.6709",
    stroke: "#F8BB54",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/Pattern2.5ddfeb05dd947c234b6f61081c31eb5b.svg";
export { ForwardRef as ReactComponent };